import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import networkApi from "../../network/api";
import { SandboxNetworkData } from "../@types";
import useGraphPagination from "./useGraphPagination";

const useInitNetworkConnectionsData = (
  sandboxNetworkData?: SandboxNetworkData
) => {
  const { cuckoo, cape, fireeye, joe } = sandboxNetworkData || {};
  const networkConnections = useMemo(
    () => [
      ...(joe?.map(obj => obj.ip || obj.uri) ?? []),
      ...(cuckoo?.map(obj => obj.ip || obj.uri) ?? []),
      ...(cape?.map(obj => obj.ip || obj.uri) ?? []),
      ...(fireeye?.map(obj => obj.ip || obj.uri) ?? [])
    ],
    [cuckoo, cape, fireeye, joe]
  );

  const {
    data: pagedNetworkConnections,
    goToNext: loadMoreNetworkConnections
  } = useGraphPagination(networkConnections, { pageSize: 20 });

  const { data: sandboxNetworkDataMerged, isFetching } = useQuery({
    queryKey: ["networkReputationNetworkConnections", pagedNetworkConnections],
    queryFn: () => networkApi.urlReputation(pagedNetworkConnections),
    enabled: Boolean(pagedNetworkConnections?.length),
    select: ({ data }) => data.entries,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  return {
    data: {
      sandboxNetworkDataMerged
    },
    counts: {
      totalNetworkConnections: networkConnections?.length ?? 0
    },
    actions: { loadMoreNetworkConnections },
    isFetching
  };
};

export default useInitNetworkConnectionsData;
